import UIImageComponent from '../../../Component/UI/Image';
import {BackCardCollectionType} from "../../../Prototype/UI/BackCardCollectionType";
import SectionBaseHandler from './SectionBaseHandler';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import BackCardCollectionItem from '../../../Prototype/UI/BackCardCollectionItem';
import BackCardItem from '../../../Prototype/UI/BackCardItem';
import Game from '../../../Game';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import Renderable from '../../../Component/Renderable';
import Interactable from '../../../Component/Interactable';
import GameObject from '../../../GameObject/GameObject';
import SideMenuSectionCard from '../../../Prototype/UI/SideMenuSectionCard';

const SECTION = 'main_container/sections';

export default class SectionCardsHandler extends SectionBaseHandler {
    private backCardCollectionItems: BackCardCollectionItem[];
    private backCardItems: BackCardItem[];

    // tslint:disable-next-line: no-empty
    public handleStateChanged(): void {}

    protected onCreate(): void {
        // Instantiate card section.
        this.section = GameObject.Instantiate(SideMenuSectionCard);
        this.parent.element.find(SECTION).addChild(this.section);

        const cardsContainer = this.section.find('cards_list');
        const backcardTextures = Game.state.getState().playerState.backcards;
        const collections = Object.keys(BackCardCollectionType).length;

        // Add 3 cards for each collection.
        for (let i = backcardTextures.length, n = collections * 3; i < n; i++) {
            backcardTextures.push(0);
        }

        // Add a collection type.
        this.backCardCollectionItems = [];
        this.backCardItems = [];
        Object.keys(BackCardCollectionType).forEach(
            (type: string, index: number) => {
                const backs = this.parent.system.state.getState().playerState
                    .backcards;

                const cards = [index * 3 + 1, index * 3 + 2, index * 3 + 3];

                const unlocked = cards.map(index =>
                    Number.isNaN(backs[index - 1]) ? false : backs[index - 1] > 0
                );

                const child = GameObject.Instantiate(BackCardCollectionItem, {
                    type: BackCardCollectionType[type as any],
                    cards: cards,
                    unlocked: unlocked,
                });
                this.backCardCollectionItems.push(child);
                cardsContainer.addChild(child);

                this.backCardItems.push.apply(
                    this.backCardItems,
                    child.children.filter(x => x instanceof BackCardItem)
                );
            }
        );

        // Setup backcards.
        for (let i = 0, n = this.backCardItems.length; i < n; i++) {
            this.showBackCardItem(this.backCardItems[i], i);
        }

        this.highlightCurrentBackcard();

        this.parent.system.state.dispatch(PlayerActions.seeNewBackcards());
    }

    private async showBackCardItem(item: GameObject, index: number) {
        const itemUnlocked = item.getChildByName('unlocked');

        if (itemUnlocked) {
            const key = `backcard_${index + 1}`;
            Game.resource.add(
                key,
                `resource/graphics/card_backs/${key}.png`
            );
            await Game.resource.wait(key);

            if (item.destroyed) return;

            itemUnlocked.getComponent(UIImageComponent).texture = key;

            item.addComponent(Interactable, {
                enabled: true,
                buttonMode: true,
            });
            item.on(GameObjectEvent.SELECTED, () => {
                this.parent.system.state.dispatch(
                    PlayerActions.selectBackCard(item.name)
                );
                this.highlightCurrentBackcard();
            });
        }
    }

    protected onDestroy(): void {
        // Remove all backcards and remove their listeners.
        for (let i = this.backCardItems.length - 1; i >= 0; i--) {
            this.backCardItems[i].off(GameObjectEvent.SELECTED);
            this.backCardItems[i].destroy();
            this.backCardItems[i] = null;
        }
        this.backCardItems = null;

        // Remove all backcard collections.
        for (let i = this.backCardCollectionItems.length - 1; i >= 0; i--) {
            this.backCardCollectionItems[i].destroy();
            this.backCardCollectionItems[i] = null;
        }
        this.backCardCollectionItems = null;
    }

    private highlightCurrentBackcard(): void {
        const textureName: string = Game.state.getState().playerState.backcard;
        for (let i = 0, n = this.backCardItems.length; i < n; i++) {
            const unlockedSprite = this.backCardItems[i].getChildByName(
                'unlocked'
            );
            if (unlockedSprite) {
                unlockedSprite
                    .getChildByName('highlight')
                    .getComponent(Renderable).visible =
                    this.backCardItems[i].name === textureName;
            }
        }
    }
}
